import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './AuthContext';
import RiotLoginPage from './pages/RiotLoginPage';
import DiscordCallbackPage from './pages/DiscordCallbackPage';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import TeamsPage from './pages/TeamsPage';
import AdminPage from './pages/AdminPage';
import TournamentPage from './pages/TournamentPage';
import TeamPage from './pages/TeamPage';
import ProfilePage from './pages/ProfilePage';
import TournamentsPage from './pages/TournamentsPage';
import InvitePage from './pages/InvitePage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import CGUPage from './pages/CGUPage';
import './App.css';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/riot-login" />;
}

// Admin Route Component
function AdminRoute({ children }) {
  const { isAuthenticated, loading, user } = useContext(AuthContext);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!isAuthenticated) return <Navigate to="/riot-login" />;
  if (user?.role !== 'admin') return <Navigate to="/dashboard" />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <>
      <Navigation />
      <main className="main-content">
        <Routes>
          {/* Auth */}
          <Route path="/riot-login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <RiotLoginPage />} />
          <Route path="/auth/discord/callback" element={<DiscordCallbackPage />} />

          {/* Redirects for old routes */}
          <Route path="/login" element={<Navigate to="/riot-login" replace />} />
          <Route path="/register" element={<Navigate to="/riot-login" replace />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/teams" element={<TeamsPage />} />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            }
          />

          {/* Liste publique tournois à venir */}
          <Route path="/tournaments" element={<TournamentsPage />} />

          {/* Tournament detail (public) */}
          <Route path="/tournament/:id" element={<TournamentPage />} />

          {/* Team detail (public) */}
          <Route path="/team/:id" element={<TeamPage />} />

          {/* Profile */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />

          {/* Invitation externe — lien reçu par email */}
          <Route path="/invite/:token" element={<InvitePage />} />

          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Pages légales */}
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="/cgu" element={<CGUPage />} />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <AppRoutes />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
